/**
 * @generated SignedSource<<c4f741c668641b2e36912178d2e9ac46>>
 * @relayHash 94a9934889587d362bd0d83d6e2ed25d
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/542.0.0-2026-01-13T16:17:28.812Z/nftPublicProfileEditMutation

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PublicProfileEditErrorReason = "BIO_CONTAINS_PROFANITY" | "DISPLAYNAME_CONTAINS_PROFANITY" | "USERNAME_CONTAINS_PROFANITY" | "USERNAME_INVALID_FORMAT" | "USERNAME_TAKEN" | "%future added value";
export type PublicProfileStatus = "ACTIVE" | "INACTIVE" | "%future added value";
export type PublicProfileEditInput = {
  avatarImageId?: string | null;
  bio?: string | null;
  clientMutationId?: string | null;
  discordLink?: string | null;
  displayName?: string | null;
  facebookLink?: string | null;
  heroImageId?: string | null;
  instagramLink?: string | null;
  status?: PublicProfileStatus | null;
  twitterLink?: string | null;
  userId: string;
  username: string;
  webLink?: string | null;
  wikipediaLink?: string | null;
};
export type nftPublicProfileEditMutation$variables = {
  input: PublicProfileEditInput;
};
export type nftPublicProfileEditMutation$data = {
  readonly publicProfileEdit: {
    readonly errorReason: PublicProfileEditErrorReason | null;
    readonly publicProfile: {
      readonly " $fragmentSpreads": FragmentRefs<"NftPublicProfileEditForm_publicProfile">;
    } | null;
  } | null;
};
export type nftPublicProfileEditMutation = {
  response: nftPublicProfileEditMutation$data;
  variables: nftPublicProfileEditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorReason",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "path",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Photo",
    "kind": "LinkedField",
    "name": "parent",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "storageKey": null
  },
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "nftPublicProfileEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PublicProfileEditPayload",
        "kind": "LinkedField",
        "name": "publicProfileEdit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PublicProfile",
            "kind": "LinkedField",
            "name": "publicProfile",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NftPublicProfileEditForm_publicProfile"
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "nftPublicProfileEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PublicProfileEditPayload",
        "kind": "LinkedField",
        "name": "publicProfileEdit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PublicProfile",
            "kind": "LinkedField",
            "name": "publicProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "username",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bio",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Photo",
                "kind": "LinkedField",
                "name": "avatarImage",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Photo",
                "kind": "LinkedField",
                "name": "heroImage",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "webLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "discordLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "instagramLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "facebookLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wikipediaLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "twitterLink",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/542.0.0-2026-01-13T16:17:28.812Z/nftPublicProfileEditMutation",
    "metadata": {},
    "name": "nftPublicProfileEditMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "d9466ab63f5730c80301fe88bd28071d";

export default node;
